
import { mapState, mapActions } from "vuex";

import RiderDetails from "../common/rider-details-template.vue";
import CancelAndAssignNewRiderDialog from "../dialogs/cancel-and-assign-new-rider-dialog.vue";
import OrderDetailsWaitingForNewRider from "./order-details-waiting-for-new-rider.vue";
export default {
  components: {
    RiderDetails,
    CancelAndAssignNewRiderDialog,
    OrderDetailsWaitingForNewRider
  },
  props: {
    orderDetails: {
      default: () => {},
      typpe: Object
    }
  },
  data() {
    return {
      showCancelAndRequestNewRiderDialog: false,
      loading: false,
      showDelayedWaitingScreen: false,
      cancelButtonDisabled: false,
      disableButtonTimer: null,
      RiderStatuses: [
        { id: "driver_assigned", color: "red", label: "Assigned" },
        { id: "shipped", color: "yellow", label: "Picked up" },
        { id: "complete", color: "green", label: "Delivered" }
      ]
    };
  },
  computed: {
    ...mapState("restaurant", ["locationDetails"]),
    shouldShowDeliveryStatus() {
      return !!(
        this.orderDetails.rider_status &&
        this.isPorterDelivery &&
        this.isWhatsappOrderAndHomeDelivery
      );
    },

    isPorterDelivery() {
      return this.orderDetails.delivery_partner === "porter";
    },
    isWhatsappOrderAndHomeDelivery() {
      return (
        this.orderDetails.order_type !==
          this.$constants.OrderTypes.TAKE_AWAY.id &&
        this.getChannelConstObj(this.orderDetails.source).name ===
          this.$constants.Channels.WHATSAPP.name
      );
    },
    isOrderInProcess() {
      return (
        this.orderDetails.status ===
          this.$constants.OrderStatuses.PREPARING.id ||
        this.orderDetails.status ===
          this.$constants.OrderStatuses.READY_FOR_DELIVERY.id
      );
    },

    showCancelAndRequestNewRider() {
      return (
        this.isWhatsappOrderAndHomeDelivery &&
        this.isPorterDelivery &&
        this.isOrderInProcess
      );
    },
    isAssignmentDelayResolved() {
      const { rider_status, assignment_delay_type, ready_at } =
        this.orderDetails;

      if (rider_status) {
        return true;
      }

      if (assignment_delay_type === "immediate") {
        return true;
      }

      if (assignment_delay_type === "custom") {
        return this.showDelayedWaitingScreen;
      }

      if (assignment_delay_type === "prepared") {
        return !!(
          this.showDelayedWaitingScreen ||
          (ready_at && new Date() >= new Date(ready_at))
        );
      }

      return false;
    },

    isWaitingForNewRider() {
      return (
        (this.orderDetails?.rider_status?.status === "cancelled" &&
          this.isAssignmentDelayResolved &&
          this.showCancelAndRequestNewRider) ||
        (!this.orderDetails?.rider_status &&
          this.showCancelAndRequestNewRider &&
          this.isAssignmentDelayResolved)
      );
    }
  },
  beforeMount() {
    this.handleAssignmentDelayType();
  },
  methods: {
    ...mapActions("reciever", ["cancelAndAssignNewRider"]),
    handleAssignmentDelayType() {
      const {
        assignment_delay_type,
        assignment_delay_minutes,
        ready_at,
        accepted_at
      } = this.orderDetails;
      if (assignment_delay_type === "custom") {
        this.showDelayedWaitingScreen = false;

        if (assignment_delay_minutes && accepted_at) {
          const acceptedTimestamp = new Date(accepted_at).getTime();
          const delayMilliseconds = assignment_delay_minutes * 60 * 1000;
          const targetExecutionTime = acceptedTimestamp + delayMilliseconds;
          const currentTimestamp = Date.now();

          const actualDelay = Math.max(
            targetExecutionTime - currentTimestamp,
            0
          );

          console.log(
            "Start time:",
            new Date(currentTimestamp).toLocaleString()
          );
          console.log(
            "Expected execution time:",
            new Date(targetExecutionTime).toLocaleString()
          );
          console.log("Actual delay in minutes:", actualDelay / 60000);

          if (actualDelay <= 0) {
            console.log(
              "Execution time already passed. Triggering immediately."
            );
            this.showDelayedWaitingScreen = true;
          } else {
            setTimeout(() => {
              console.log(
                "Execution time:",
                new Date(Date.now()).toLocaleString()
              );
              this.showDelayedWaitingScreen = true;
            }, actualDelay);
          }
        }
      }
      if (assignment_delay_type === "prepared") {
        this.showDelayedWaitingScreen = false;
        if (ready_at) {
          this.showDelayedWaitingScreen = true;
        }
      }
    },
    getRiderStatusConstObj(status) {
      const foundStatus = this.RiderStatuses.find(
        (riderStatus) => riderStatus.id === status
      );
      return foundStatus || null;
    },
    handleCancelAndRequestNewRiderSubmission(selectedReason) {
      this.loading = true;
      this.cancelAndAssignNewRider({
        orderId: this.orderDetails.id,
        payload: {
          cancel_reason: selectedReason
        }
      })
        .then((response) => {
          if (response.status === 200) {
            this.showCancelAndRequestNewRiderDialog = false;
            this.startDisableButtonTimer();
          } else {
            this.$nuxt.$emit("show-error-toast", response);
          }
        })
        .catch((errr) => {
          this.$nuxt.$emit("show-error-toast", errr);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    startDisableButtonTimer() {
      this.cancelButtonDisabled = true;
      if (this.disableButtonTimer) {
        clearTimeout(this.disableButtonTimer);
      }
      this.disableButtonTimer = setTimeout(() => {
        this.cancelButtonDisabled = false;
      }, 120000);
    }
  }
};
